import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '@environment';
import { UserService } from '@shared/core';
import { MenuItem } from '../types';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class HeaderMenuService {
  private menu: MenuItem[] = [
    {
      name: 'mainLayout.menu.physicalPersons',
      roles: [],
      children: [
        {
          name: 'mainLayout.menu.search',
          path: '/persons',
          roles: [],
        },
        {
          name: 'mainLayout.menu.createPhysicalPerson',
          path: '/persons/create',
          roles: [],
        },
      ],
    },
    {
      name: 'mainLayout.menu.companies',
      roles: [],
      children: [
        {
          name: 'mainLayout.menu.search',
          path: '/companies',
          roles: [],
        },
        {
          name: 'mainLayout.menu.createCompany',
          path: '/companies/create',
          roles: [],
        },
      ],
    },
    {
      name: 'mainLayout.menu.sales',
      roles: ['ROLE_CRM2_EXECUTE_TASK', 'ROLE_CRM2_MANAGE_OPERATORS', 'ROLE_CRM2_CONFIGURE_BUSINESS_PROCESS_ENTITIES'],
      children: [
        {
          name: 'mainLayout.menu.tasks',
          path: '/persons/tasks',
          roles: ['ROLE_CRM2_EXECUTE_TASK'],
        },
        {
          name: 'mainLayout.menu.taskTypes',
          path: '/admin/task-execution/task-types',
          roles: ['ROLE_CRM2_CONFIGURE_BUSINESS_PROCESS_ENTITIES'],
        },
        {
          name: 'mainLayout.menu.taskOptions',
          path: '/admin/task-execution/task-options',
          roles: ['ROLE_CRM2_CONFIGURE_BUSINESS_PROCESS_ENTITIES'],
        },
        {
          name: 'mainLayout.menu.operatorManagement',
          path: '/admin/operators/operators',
          roles: ['ROLE_CRM2_MANAGE_OPERATORS'],
        },
        {
          name: 'mainLayout.menu.operatorGroupManagement',
          path: '/admin/operators/groups',
          roles: ['ROLE_CRM2_MANAGE_OPERATORS'],
        },
        {
          name: 'mainLayout.menu.firstLineGroupManagement',
          path: '/admin/operators/first-line-groups',
          roles: ['ROLE_CRM2_MANAGE_OPERATORS'],
        },
        {
          name: 'mainLayout.menu.corporateManagers',
          path: '/admin/managers/support-managers',
          roles: ['ROLE_CRM2_MANAGE_OPERATORS'],
        },
        {
          name: 'mainLayout.menu.salesPoints',
          path: '/admin/sales-points',
          roles: ['ROLE_CRM2_MANAGE_SALE_POINTS'],
        },
        {
          name: 'mainLayout.menu.pds',
          path: '/pds',
          roles: ['ROLE_CRM2_MANAGE_OPERATORS'],
        },
      ],
    },
    {
      name: 'mainLayout.menu.selection',
      roles: ['ROLE_CRM2_MANAGE_OPERATORS', 'ROLE_CRM2_EXECUTE_TASK', 'ROLE_CRM2_CONFIGURE_BUSINESS_PROCESS_ENTITIES'],
      children: [
        {
          name: 'mainLayout.menu.tasks',
          path: '/teachers-schedule/tasks',
          roles: ['ROLE_CRM2_EXECUTE_TASK'],
        },
        {
          name: 'mainLayout.menu.taskTypes',
          path: '/teachers-schedule/admin/task-types',
          roles: ['ROLE_CRM2_CONFIGURE_BUSINESS_PROCESS_ENTITIES'],
        },
        {
          name: 'mainLayout.menu.operatorManagement',
          path: '/teachers-schedule/admin/operators',
          roles: ['ROLE_CRM2_MANAGE_OPERATORS'],
        },
      ],
    },
    {
      name: 'mainLayout.menu.group',
      roles: ['ROLE_CRM2_GROUP_LESSONS_EXECUTE_SCHEDULING_TASK', 'ROLE_CRM2_GROUP_LESSONS_MANAGE_SCHEDULING_OPERATORS'],
      children: [
        {
          name: 'mainLayout.menu.tasks',
          path: '/group-schedule/tasks',
          roles: ['ROLE_CRM2_GROUP_LESSONS_EXECUTE_SCHEDULING_TASK'],
        },
        {
          name: 'mainLayout.menu.operatorManagement',
          path: '/group-schedule/admin/operators',
          roles: [
            'ROLE_CRM2_GROUP_LESSONS_MANAGE_SCHEDULING_OPERATORS',
            'ROLE_CRM2_GROUP_LESSONS_EXECUTE_SCHEDULING_TASK',
          ],
        },
      ],
    },
    {
      name: 'mainLayout.menu.css.header',
      roles: [
        'ROLE_CRM2_MANAGE_OPERATORS',
        'ROLE_CRM2_CONFIGURE_BUSINESS_PROCESS_ENTITIES',
        'ROLE_CRM2_EXECUTE_TASK',
        'ROLE_CRM2_CUSTOMER_SUPPORT_LETTERS',
        'ROLE_CRM2_CUSTOMER_SUPPORT_CALLS',
        'ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS',
        'ROLE_CRM2_CUSTOMER_SUPPORT_MANAGE_STK_VIRTUAL_LIST',
      ],
      children: [
        {
          name: 'mainLayout.menu.css.tasks_css',
          path: '/customer-support/start',
          roles: [
            'ROLE_CRM2_CUSTOMER_SUPPORT_LETTERS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_CALLS',
            'ROLE_CRM2_EXECUTE_TASK',
            'ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW',
          ],
        },
        {
          name: 'mainLayout.menu.css.personal_manager_binding',
          path: '/customer-support/personal-support',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_MANAGE_PERSONAL_MANAGERS', 'ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS'],
        },
        {
          name: '',
          divider: true,
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: 'mainLayout.menu.css.tasks_control',
          path: '/customer-support/admin/task-type',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: 'mainLayout.menu.css.strategy',
          path: '/customer-support/admin/weight-calculation/strategy',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: 'mainLayout.menu.css.options_control',
          path: '/customer-support/admin/task-type-option',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: 'mainLayout.menu.css.resolutions_control',
          path: '/customer-support/admin/resolution',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: 'mainLayout.menu.css.stk_virtual_list',
          path: '/customer-support/admin/stk-virtual-list',
          roles: [
            'ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW',
            'ROLE_CRM2_CUSTOMER_SUPPORT_MANAGE_STK_VIRTUAL_LIST',
          ],
        },
        {
          name: 'mainLayout.menu.css.stk',
          path: '/customer-support/admin/stk',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: 'mainLayout.menu.css.form',
          path: '/customer-support/admin/form',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: 'mainLayout.menu.css.field',
          path: '/customer-support/admin/field',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: '',
          divider: true,
          roles: [
            'ROLE_CRM2_CUSTOMER_SUPPORT_MANAGE_OPERATORS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW',
          ],
        },
        {
          name: 'mainLayout.menu.css.operators_control',
          path: '/customer-support/operators',
          roles: [
            'ROLE_CRM2_CUSTOMER_SUPPORT_MANAGE_OPERATORS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW',
          ],
        },
        {
          name: 'mainLayout.menu.css.operator_groups_control',
          path: '/customer-support/admin/operator-groups',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS', 'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW'],
        },
        {
          name: '',
          divider: true,
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS'],
        },
        {
          name: 'mainLayout.menu.css.close_task',
          path: '/customer-support/admin/task-close',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS'],
        },
        {
          name: 'mainLayout.menu.css.csv-task-creation',
          path: '/customer-support/batch-tasks-creation',
          roles: ['ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS'],
        },
        {
          name: 'mainLayout.menu.css.webinar_rooms',
          path: '/customer-support/admin/webinar-rooms',
          roles: [
            'ROLE_CRM2_CUSTOMER_SUPPORT_FULL_ACCESS',
            'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_EDIT',
            'ROLE_CRM2_CUSTOMER_SUPPORT_ADMIN_VIEW',
            'ROLE_VIMBOX_WEBINAR_CHAT_MODERATE',
          ],
        },
      ],
    },
    {
      name: 'mainLayout.menu.instruments',
      roles: [],
      children: [
        {
          name: 'mainLayout.menu.distributionOfLetters',
          path: '/persons/mail-sorter',
          roles: [],
        },
        {
          name: 'mainLayout.menu.correctionSTK',
          path: '/admin/tools/stk-correction',
          roles: ['ROLE_CRM2_CORRECT_STK'],
        },
        {
          name: 'mainLayout.menu.serviceReport',
          path: '/admin/tools/profiling-education-service',
          roles: [],
        },
        {
          name: 'mainLayout.menu.unreadWhatsappMessages',
          path: '/persons/messenger/unread-notifications',
          roles: [],
        },
        {
          name: 'mainLayout.menu.templatesEditor',
          path: '/admin/pil/templates',
          roles: ['ROLE_CRM2_BUSINESS_ANALYST', 'ROLE_CRM2_QA'],
        },
        {
          name: 'mainLayout.menu.wfm',
          path: '/wfm',
          roles: [
            'ROLE_WFM_GET_FORECAST_LIST',
            'ROLE_WFM_GET_SCHEDULE_WITH_FORECAST',
            'ROLE_WFM_GET_OPERATOR_SCHEDULE',
          ],
        },
      ],
    },
    {
      name: 'mainLayout.menu.services',
      roles: [],
      children: [
        {
          name: 'mainLayout.menu.balanceCheck',
          externalLink: `https://accounting.${environment.baseHost}/userpayment/search/transaction`,
          roles: [],
        },
        {
          name: 'mainLayout.menu.phasedPayTransactions',
          externalLink: `https://accounting.${environment.baseHost}/credit/list`,
          roles: [],
        },
        {
          name: 'mainLayout.menu.loginLink',
          externalLink: `${environment.id.host}/admin/auth/login-links`,
          roles: [],
        },
        {
          name: 'mainLayout.menu.accruals',
          externalLink: `${environment.billingMarketing.host}accrual-operations/create`,
          roles: [],
        },
        {
          name: 'mainLayout.menu.schedule',
          externalLink: `https://timetable.${environment.baseHost}/`,
          roles: [],
        },
        {
          name: 'mainLayout.menu.overbooking',
          externalLink: `https://c1.${environment.baseHost}`,
          roles: [],
        },
        {
          name: 'mainLayout.menu.omnidesk',
          externalLink: 'https://skyeng.omnidesk.ru/l_rus/',
          roles: [],
        },
        {
          name: 'mainLayout.menu.usedesk',
          externalLink: 'https://secure.usedesk.ru/login',
          roles: [],
        },
        {
          name: 'mainLayout.menu.oecabinetLink',
          externalLink: `https://oecabinet.${environment.baseHost}`,
          roles: ['ROLE_OPERATIONS_EMPLOYEE_CABINET_VIEW_OPERATORS_DATA'],
        },
      ],
    },
  ];

  constructor(
    private userService: UserService,
    private transloco: TranslocoService,
  ) {}

  get(): Observable<MenuItem[]> {
    return of(this.getMenuForUser(this.menu));
  }

  private getMenuForUser(menuTree: MenuItem[]): MenuItem[] {
    return menuTree
      .reduce((resultMenu: MenuItem[], menuItem: MenuItem) => {
        const isParentAllowed: boolean =
          menuItem.roles.length === 0 || menuItem.roles.some(perm => this.userService.hasRole(perm));

        const name = this.transloco.translate(menuItem.name);
        menuItem = {
          ...menuItem,
          name: name,
        };

        if (!isParentAllowed) {
          return resultMenu;
        }

        if (!menuItem.children) {
          return [...resultMenu, menuItem];
        }

        return [
          ...resultMenu,
          {
            ...menuItem,
            children: this.getMenuForUser(menuItem.children),
          },
        ];
      }, [])
      .filter((menuItem: MenuItem) => {
        return menuItem.children ? menuItem.children.length > 0 : true;
      });
  }
}
